import React from "react"

import { Redirect, withRouter } from "react-router-dom"
import { Form, Icon, Input, Button, Tooltip, message } from 'antd'
import { Auth } from "aws-amplify"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

import LoginBase from './LoginBase'

class ResetPasswordForm extends React.Component{

    onSubmit(e) {

        e.preventDefault()
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                this.props.CallLogin()

                let requiredAttributes = {}
                this.props.login.user.challengeParam.requiredAttributes.forEach((value)=>{
                    requiredAttributes[value] = values[value]
                })

                this.handleSubmit(values["new-password"], requiredAttributes)
            }
        })
    }

    async handleSubmit(newPassword, requiredAttributes) {
        try {
            await Auth.completeNewPassword(
                this.props.login.user,
                newPassword,
                requiredAttributes
            );
            message.success("Constraseña reestablecida")
            this.props.EndCallLogin()
            this.props.history.push('/')
        } catch (e) {
            message.error(e.code)
            switch(e.code){
                case 'CodeDeliveryDetails':
                    message.error('Error intentando recuperar contraseña. Por favor, crea un nuevo usuario')
                    this.props.EndCallLogin()
                    break;
                case 'NotAuthorizedException':
                    message.error('Ocurrio un error, por favor contacta a los administradores.')
                    this.props.EndCallLogin()
                    break;
                case 'ExpiredCodeException':
                    message.error('El codigo ingresado ha expirado. Por favor, solicita uno nuevo.')
                    this.props.EndCallLogin()
                    break;
                default:
                    message.error('Ocurrio un error. Por favor, contacta a los administradores - codigo: '+e.code)
                    this.props.EndCallLogin()
                    break;
            }
            this.props.EndCallLogin()
        }
    }

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('new-password')) {
            callback('The passwords do not match');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value) {
            form.validateFields(['confirm_password'], { force: true });
        }
        callback();
    };

    render() {

        const { getFieldDecorator } = this.props.form;

        if (this.props.login.fechingStatus === true){
            return null;
        }
        else if (this.props.login.user === null || this.props.login.user === undefined) {
            return <Redirect to="/login" />;
        }
        else if (this.props.login.calling === false && this.props.login.auth === true ) {
            return <Redirect to="/" />;
        }
        else {
            return (
                <LoginBase title="Ingrese una contraseña">
                    <Form
                        onSubmit={(e)=>this.onSubmit(e)}
                        hideRequiredMark={true}
                    >
                        <Form.Item
                        >
                        {
                            getFieldDecorator('user', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Nombre de usuario requerido',
                                    },
                                ],
                                initialValue: this.props.login.user.challengeParam.userAttributes.email
                            })(<Input
                                    prefix={<Icon type="user" />}
                                    placeholder="Usuario"
                                    suffix={
                                        <Tooltip title="Ingrese su usuario">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    disabled={true}
                                />)
                        }
                        </Form.Item>

                        {
                            this.props.login.user.challengeParam.requiredAttributes.map((value)=>{
                                return (
                                    <Form.Item key={value}>
                                        {
                                            getFieldDecorator(value, {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: value + ' requerido',
                                                    },
                                                ]
                                            })(<Input
                                                    placeholder={value}
                                                    suffix={
                                                        <Tooltip title={"Ingrese " + value}>
                                                            <Icon type="info-circle" />
                                                        </Tooltip>
                                                    }
                                                />)
                                        }
                                    </Form.Item>
                                )
                            })
                        }
                        <Form.Item>
                        {
                            getFieldDecorator('new-password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Contraseña requerida',
                                    },
                                    {
                                        validator: this.validateToNextPassword
                                    }
                                ],
                            })(<Input.Password
                                    prefix={<Icon type="lock" />}
                                    placeholder="Nueva constraseña"
                                    type="password"
                                    autoComplete="new-password"
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('confirm_password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Confirmacion de contraseña requerida',
                                    },
                                    {
                                        validator: this.compareToFirstPassword
                                    }
                                ],
                            })(<Input.Password
                                    prefix={<Icon type="lock" />}
                                    placeholder="Confirme la contraseña"
                                    type="password"
                                    autoComplete="off"
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{marginTop:"40px"}}
                                loading={this.props.login.calling}
                            >
                                Cambiar contraseña
                            </Button>
                        </Form.Item>
                    </Form>
                </LoginBase>
            )
        }
    }
}

const ResetPassword = Form.create({ name: 'reset-password' })(ResetPasswordForm);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPassword));
